import { useEffect } from 'react';
import { WrappedFormUtils } from '@ant-design/compatible/lib/form/Form';
import { PRODUCT_WIDGET_LAYOUT_TYPE_V2, ProductWidgetDetailV2, WidgetProductItem } from '../../../../../types/widget';
import { WIDGET_PRODUCT_RANDOM_ITEM_COUNT_SELECT_LIST_V2 } from '../../../../../constants/service/app/widgetConstantsV2';

type UseProductWidgetFormReturnType = {
  isEventConnect?: ProductWidgetDetailV2['isEventConnect'];
  widgetItemProducts: ProductWidgetDetailV2['widgetItemProducts'];
  event: ProductWidgetDetailV2['event'];
  layoutType?: ProductWidgetDetailV2['layoutType'];
  setIsEventConnect: (isEventConnect: boolean) => void;
  setLayoutType: (layoutType: PRODUCT_WIDGET_LAYOUT_TYPE_V2) => void;
  setWidgetItemProducts: (list: WidgetProductItem[]) => void;
};

interface UseProductWidgetFormProps {
  form: WrappedFormUtils;
  initialValue: Partial<ProductWidgetDetailV2>;
  isEdit: boolean;
}

export const useProductWidgetForm = (props: UseProductWidgetFormProps): UseProductWidgetFormReturnType => {
  const { form, initialValue, isEdit } = props;

  const { widgetItemProducts, exposureWidgetItemProducts, event, layoutType, isEventConnect } = form.getFieldsValue([
    'widgetItemProducts',
    'exposureWidgetItemProducts',
    'event',
    'layoutType',
    'isEventConnect',
  ]) as Pick<
    Partial<ProductWidgetDetailV2>,
    'widgetItemProducts' | 'exposureWidgetItemProducts' | 'event' | 'layoutType' | 'isEventConnect'
  >;

  useEffect(() => {
    form.setFieldsValue(initialValue);
  }, []);

  const handleToggleEventConnection = (isEventConnect: boolean): void => {
    if (isEventConnect && !isEdit) {
      form.setFieldsValue({ isProductRecommend: false });
    }
  };

  const handleChangeLayoutType = (layoutType: PRODUCT_WIDGET_LAYOUT_TYPE_V2): void => {
    //레이아웃 타입 바꿀때마다 노출갯수 리스트의 가장 첫번째 항목으로 설정
    form.setFieldsValue({ exposureItemCount: WIDGET_PRODUCT_RANDOM_ITEM_COUNT_SELECT_LIST_V2[layoutType][0].id });
  };

  const handleChangeWidgetItemProducts = (list: WidgetProductItem[]): void => {
    const widgetProductIdList = list.map((product) => product.id);
    form.setFieldsValue({
      exposureWidgetItemProducts: exposureWidgetItemProducts?.filter((item) => widgetProductIdList.includes(item.id)),
    });
  };

  return {
    isEventConnect,
    widgetItemProducts,
    event,
    layoutType,
    setIsEventConnect: handleToggleEventConnection,
    setLayoutType: handleChangeLayoutType,
    setWidgetItemProducts: handleChangeWidgetItemProducts,
  };
};
